import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { CodeModel } from '../common-code/CommonCode';
import { withSetPropAction } from '../extensions/withSetPropAction';
import { OperatorInfo } from '../operator-info/OperatorInfo';

import { Role } from './Role';

/**
 * # Group
 *
 * Group을 설명하세요.
 */
export const Group = types
  .model('Group')
  .props({
    oprtrGroupSid: types.optional(types.number, 0),
    oprtrGroupNm: types.optional(types.string, ''),
    oprtrGroupPsid: types.optional(types.maybeNull(types.number), 0),
    useYn: types.optional(types.boolean, false),
    dscrpt: types.optional(types.maybeNull(types.string), ''),
    adminRoleYn: types.optional(types.boolean, false),
    roleList: types.optional(types.maybeNull(types.array(Role)), []),
    roleIdList: types.optional(types.maybeNull(types.array(types.string)), []),
    roleNmList: types.optional(types.string, ''),
    defaultRoleOptions: types.optional(types.array(CodeModel), []),
    regUser: types.maybeNull(OperatorInfo),
    updUser: types.maybeNull(OperatorInfo),
    regDt: types.optional(types.number, 0),
    updDt: types.optional(types.number, 0),
    grpNmDuplicate: types.optional(types.boolean, false),
  })
  .actions(withSetPropAction);

// --------------------------------------------------------------------------
type TGroup = Instance<typeof Group>;
type TGroupSnapshot = SnapshotOut<typeof Group>;

export interface IGroup extends TGroup {}
export type TGroupKeys = keyof TGroupSnapshot & string;
export interface IGroupSnapshot extends TGroupSnapshot {}
export const createGroup = () => types.optional(Group, {} as TGroup);
